(function () {
    "use strict";

    // @ngInject
    function LoginControllerCtor($scope, $injector, $stateParams, $timeout, $state, AppStates, $uibModalStack, $localStorage,
                                 InitialAppLoadParamsService, UsersManager, AnalyticsService, RedirectService,
                                 UiPersistenceService, _, ClientPortalService, $window) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'LoginController';
        AnalyticsService.trackPageView(this, 'login', this.getPageViewAnalyticsArgs($stateParams, $localStorage));

        this.UsersManager = UsersManager;
        this.AnalyticsService = AnalyticsService;
        this.RedirectService = RedirectService;
        this.UiPersistenceService = UiPersistenceService;
        this._ = _;
        this.$stateParams = $stateParams;
        this.$localStorage = $localStorage;
        this.ClientPortalService = ClientPortalService;

        this.showForgotPassword = false;
        this.showResetPasswordSent = false;
        this.emailNotRecognized = false;

        if (this._isInClientPortal()) {
            this.showClientPortal = true;
        } else {
            this.user = UsersManager.newUser();
            this.loginParams = {
                loginSuccess: this.loginSuccess.bind(this),
                loginError: this.loginError.bind(this),
                user: this.user
            };

            if (this.$stateParams.vendor && this.ClientPortalService.isInClientPortal()) {
                this.portalModel = this.ClientPortalService.getConfiguration();
            }

            this.preFillUserEmail();
            this.user.lastError = $stateParams.error || InitialAppLoadParamsService.getParam('error');
            this.showSSOLogin = $state.current.name && $state.current.name.indexOf(AppStates.root_core_clientLogin) === -1;
            this.showExtendTrial = !!(InitialAppLoadParamsService.getParam('extend_trial'));
            this.showDiscountText = !!(InitialAppLoadParamsService.getParam('discount'));
            this.showReferralText = !!(InitialAppLoadParamsService.getParam('code'));
        }

        //note: 'wcb', 'lca' are for a test of redirection from marketing homepage BOAZ
        InitialAppLoadParamsService.cleanParamsFromView(['extend_trial', 'discount', 'code', 'wcb', 'lca', 'referral_source']);

        // Close any open modal so it won't be shown after login
        $uibModalStack.dismissAll();
        $window.performance && $window.performance.mark('hb_login_shown');

    }

    Controllers.LoginController = Class(Controllers.BaseController, {

        constructor: LoginControllerCtor,

        clearErrors: function clearErrors() {
            this.loginForm.attempted = false;
            //this.user.lastError = null; I marked this off as it hides the error message on input focus.
        },

        resetTheForgotForm: function resetTheForgotForm() {
            this.showForgotPassword = false;
            this.showResetPasswordSent = false;
            this.emailNotRecognized = false;
        },

        login: function login(e) {
            this.loginForm.attempted = true;

            if (this.loginForm.$invalid) {
                if (e) {
                    e.preventDefault();
                }
                return;
            }
            this.loggingIn = true;
            this.UsersManager.login(this.user, 'link', {linkId: this.$stateParams.link_id}).then(
                this.loginSuccess.bind(this),
                this.loginError.bind(this)
            );
        },

        loginSuccess: function loginSuccess(res) {
            this.loggingIn = false;
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.pipeline_view, null);
            this.RedirectService.redirect(this.user);
        },

        loginError: function loginError(resp) {
            this.loggingIn = false;

            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.login, resp);
        },

        openForgotPassword: function openForgotPassword() {
            this.showForgotPassword = true;
            this.user.lastError = '';
            this.user.password = '';
            this.loginForm.$setPristine();
        },

        sendResetPassword: function sendResetPassword(form) {

            if (!form.$valid) {
                return;
            }

            this.sendingResetPassword = true;
            var args = {
                email: this.user.email
            };
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.forgot_password_request, args);

            var params = {};
            this.UsersManager.fillExtendTrialData(params);
            this.UsersManager.sendResetPassword(this.user, params).then(
                this.resetPasswordSuccess.bind(this),
                this.resetPasswordError.bind(this)
            );
        },

        resetPasswordSuccess: function resetPasswordSuccess() {
            this.showForgotPassword = false;
            this.showResetPasswordSent = true;
            this.sendingResetPassword = false;

            var args = {
                email: this.user.email
            };
            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.forgot_password_email, args);
        },

        resetPasswordError: function resetPasswordError(resp) {
            this.sendingResetPassword = false;
            this.emailNotRecognized = true;

            var args = {
                email: this.user.email
            };
            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.forgot_password_email, resp, args);
        },

        preFillUserEmail: function preFillUserEmail() {
            if (this.$stateParams.email) {
                //if we got an email from the query string place on the input field
                this.user.email = this.$stateParams.email;
            } else if(this.$localStorage.hb_user_details) {
                this.user.email = this.$localStorage.hb_user_details.email;
            }
        },

        getPageViewAnalyticsArgs: function getPageViewAnalyticsArgs($stateParams, $localStorage) {
            var args = {};
            if ($stateParams.email) {
                //if we got an email from the query string place on the input field
                args = {
                    pre_filled_email: $stateParams.email,
                    source: 'url param'
                };
            } else if($localStorage.hb_user_details && $localStorage.hb_user_details.email) {
                args = {
                    pre_filled_email: $localStorage.hb_user_details.email,
                    pre_filled_name: $localStorage.hb_user_details.full_name,
                    source: 'local storage'
                };
            }

            return args;
        },

        _isInClientPortal: function _isInClientPortal() {
            return this.ClientPortalService.isInClientPortal() && !this.$stateParams.vendor;
        }
    });
}());

